"use strict";

define('model/study',['require','exports','module','backbone','./base','./assignment','datakit/util/url'],function (require, exports, module) {
  var Backbone = require('backbone'),
    Model = require('./base'),
    Assignment = require('./assignment'),
    url = require('datakit/util/url');
  var Study = Model.extend({
    urlRoot: '/rs/api/form/study',
    virtual: {
      organization: function organization() {
        return _.reduce(this.get('organizations') || [], function (c, org) {
          return c + org.title;
        });
      }
    },
    validation: {
      title: {
        required: true,
        minLength: 3,
        maxLength: 600
      }
    },
    fetchSummary: function fetchSummary() {
      return this.fetch({
        url: url.template('/rs/api/form/study/summary/:id', this)
      });
    },
    permissions: function permissions() {
      var study = this,
        model = new Model();
      model.url = function () {
        return url.template('/rs/api/form/study/permissions/:id', study);
      };
      return model;
    }
  }, {
    all: function all(full) {
      return this.createCollection('/rs/api/form/study/summary?full=:full').params({
        full: !!full
      });
    }
  });
  module.exports = Study;
});

